export const filterCardStatuses = (data) => {
    let filteredData = []

    for (let i = 0; i < data.length; i++) {
      if (data[i].UsedInDk === true) {
        filteredData.push(data[i].DK + " (" + data[i].EN + ")")
      }
    }

    return filteredData
  }


  export const filterCardStatusesPolice = (data) => {
    let filteredData = []
    filteredData.push(data[2].DK + " (" + data[2].EN + ")")
    filteredData.push(data[3].DK + " (" + data[3].EN + ")")

    return filteredData
  }

  
  export const filterCardStatusesPoliceKontrolKort = (data) => {
    let filteredData = []
    filteredData.push(data[2].DK + " (" + data[2].EN + ")")
    filteredData.push(data[6].DK + " (" + data[6].EN + ")")

    return filteredData
  }

  export const filterCardStatusesForInactiveKontrolKort = (data) => {
    const indices = [2, 3, 4, 5, 6, 7, 8, 9, 16, 17, 11];
    let filteredData = indices
        .filter(index => data[index] !== undefined)
        .map(index => `${data[index].DK} (${data[index].EN})`);
    
    return filteredData;
  }

  export const filterCardStatusesReplaced = (data) => {
    let filteredData = []
    filteredData.push(data[6].DK + " (" + data[6].EN + ")")
    filteredData.push(data[7].DK + " (" + data[7].EN + ")")
    filteredData.push(data[8].DK + " (" + data[8].EN + ")")
    filteredData.push(data[16].DK + " (" + data[16].EN + ")")

    return filteredData
  }

  export const filterCardStatusesRenewed = (data) => {
    let filteredData = []
    filteredData.push(data[17].DK + " (" + data[17].EN + ")")

    return filteredData
  }

  export const filterCardStatusesValidForDriving = () => {
    let data = require('../../assets/CardStatus.json')
    let filteredData = []
    filteredData.push(data[0].DK + " (" + data[0].EN + ")")
    filteredData.push(data[10].DK + " (" + data[10].EN + ")")
    filteredData.push(data[14].DK + " (" + data[14].EN + ")")
    return filteredData
  }



